import React, { useContext, useEffect, useState } from 'react'
import AgoraSignallingComponent from 'src/components/AgoraSingallingComponent/AgoraSignallingComponent'
import { DISPATCH_EVENT_KEYS } from 'src/consumer/constants'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { isRtmSignallingEnabledForPractitioner } from 'src/mentor/services/mentorPortalSignallingMode'

export default function AgoraSignallingComponentForMentors() {
  const { profileData } = useContext(ProfileContext)
  const roles = getAllRolesInBoolean()
  const [userId, setUserId] = useState(profileData?.userId)
  // RTM is opt-in per practitioner. Start false so we never pull the ~1.4MB SDK for the (default)
  // practitioners who poll instead — useMentorSignals reconciles the same signals over REST.
  const [rtmEnabled, setRtmEnabled] = useState(false)

  const shouldInitialize = roles.isTeacher

  useEffect(() => {
    if (profileData?.userId) {
      setUserId(profileData?.userId)
    }
  }, [profileData])

  useEffect(() => {
    if (!shouldInitialize || !userId) {
      return undefined
    }

    let cancelled = false

    isRtmSignallingEnabledForPractitioner().then((enabled) => {
      if (!cancelled) {
        setRtmEnabled(enabled)
      }
    })

    return () => {
      cancelled = true
    }
  }, [shouldInitialize, userId])

  if (!shouldInitialize) return <></>

  // Don't render until userId is available to prevent initialization warnings
  if (!userId) return null

  if (!rtmEnabled) return null

  return (
    <AgoraSignallingComponent
      deviceId={userId}
      dispatchEventKey={DISPATCH_EVENT_KEYS.mentorSignalingEvent}
    />
  )
}
